import Button from '@datacamp/waffles-button';
import { CheckmarkCircleIcon } from '@datacamp/waffles-icons';
import { colors } from '@datacamp/waffles-tokens';
import cx from 'classnames';
import React from 'react';
import { Trans } from 'react-i18next';
import { SUPPORT_LINK } from '../constants';
import { I18N_PLACEHOLDER, useTranslation } from '../useTranslation';
import { jsx as ___EmotionJSX } from "@emotion/react";
const FeedbackFormSuccess = _ref => {
  let {
    buttonLabel,
    children,
    extraClassName,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClick = () => {},
    title
  } = _ref;
  const {
    i18n,
    t
  } = useTranslation();
  const defaultButtonLabel = t('FeedbackFormSuccess.button');
  const defaultTitle = t('FeedbackFormSuccess.title');
  const defaultChildren = ___EmotionJSX("p", null, ___EmotionJSX(Trans, {
    components: {
      supportLink: ___EmotionJSX("a", {
        href: SUPPORT_LINK,
        rel: "noopener noreferrer",
        target: "_blank"
      }, I18N_PLACEHOLDER)
    },
    i18n: i18n,
    i18nKey: "FeedbackFormSuccess.text"
  }));
  return ___EmotionJSX("div", {
    className: cx('dc-u-ta-center dc-u-p-32', extraClassName)
  }, ___EmotionJSX(CheckmarkCircleIcon, {
    "aria-hidden": true,
    color: colors.blue
    // @ts-expect-error waffles doesn't allow custom sizes (in the type definition)
    ,
    size: 48,
    title: ""
  }), ___EmotionJSX("h3", null, title !== null && title !== void 0 ? title : defaultTitle), children !== null && children !== void 0 ? children : defaultChildren, ___EmotionJSX(Button, {
    appearance: "primary",
    dataAttributes: {
      cy: 'report-success-button'
    },
    intent: "success",
    onClick: onClick
  }, buttonLabel !== null && buttonLabel !== void 0 ? buttonLabel : defaultButtonLabel));
};
FeedbackFormSuccess.displayName = 'FeedbackForm.Success';
export default FeedbackFormSuccess;